var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgM43(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5433_44405",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5433_44405",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABzElEQVRo3u2aPW6DMBTHs3XLnJvQBnKBAkMykKFInZIDsHOBcJ1eBKkslSo2SHqBRI0ofS81KqUQXD4Mz6ql3xIH+/83/n5MJv/pO8WGNgXmgA04gMtw2G+YNx2N4MjQULQCeIAPJEBaQ8L+i8/cxro2SEvfABsg4BBcB5axxTL7F65fWtwCwg6EF8Ey13tD7a3VZ8BTD8KLYB2zrsWrQCxAfAbWpXYlfgUcBYrPwDpXXYg/DyA+49zYBOs2xwHF59+E2mTANurzhwczfXtcloJ5LcYE38DGaazNbPP++pJWJcxrOTtxtf66zSvv0QBi8ayw4YgNhFdXbLakpyM2gGyv9f2AgIEg0helra90Me0JMIAoZQY8Qga8MgM+IQN+2UkqIWQg+XGyY0e92hUWBdTxcTpVGsA8njI4V+x53oBd9wBuBUQlrIvDgJ034BA04OQNuAQNuFIZIN+FyA9i8tMo7YWM/FaC4GZuJ+F2+uvek8aBxtRIHyk38h7qmQmL7LXKxYA54ost3mgO6atFKS53cyaWZK/XpQhwFLpTRDLEJEWQT2CYFcruKcxaEeh+JhXo/mXkfpHtYncNPzVQhLT4Hz/2uCPzsccY0iczm7gkRzkAgQAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM43);
export default __webpack_public_path__ + "static/media/m43.369f048f772216780c9965ffa7eec6e9.svg";
export { ForwardRef as ReactComponent };